import React from 'react';
import DatePicker, {DateObject} from "react-multi-date-picker";
import InputDate from "./input-date";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

export const types= {
    "PERSIAN_DATE":"PERSIAN_DATE",
    "GREGORIAN_DATE":"GREGORIAN_DATE",
}
const Input = ({inputClassName, value, onChange, placeholder, type})=>{
    const timestamp = Number(value);
    const dateValue = Number.isFinite(timestamp) && timestamp > 0
        ? new DateObject(timestamp * 1000)
        : null;
    const handleChange = (date) => {
        onChange?.({value: date?.toUnix?.() ?? null});
    };

    switch (type) {

        case types.PERSIAN_DATE:return (
            <DatePicker value={dateValue} onChange={handleChange} containerClassName={inputClassName} render={<InputDate label={placeholder} className={`${inputClassName}`} />} calendar={persian} locale={persian_fa} calendarPosition="bottom-right"/>
        )

        case types.GREGORIAN_DATE:return (
            <DatePicker className="english-font" value={dateValue} onChange={handleChange} containerClassName={inputClassName} render={<InputDate placeholder={placeholder} className={`${inputClassName} english-font`} />}  calendarPosition="bottom-right"/>
        )

        default: return(
            <DatePicker value={dateValue} onChange={handleChange} containerClassName={inputClassName} render={<InputDate placeholder={placeholder} className={`${inputClassName}`} />} calendar={persian} locale={persian_fa} calendarPosition="bottom-right"/>
        )
    }
}
function PrimeDatePicker({inputClassName, value, onChange, placeholder, type}) {
    return (<Input inputClassName={inputClassName} value={value} onChange={onChange} placeholder={placeholder} type={type}/>);
}


export default PrimeDatePicker;
